import type { Tracker } from '../../../core';
import type { PageViewController } from './types';

const controllers = new WeakMap<Tracker, PageViewController>();

/** 自动采集安装成功后可获取控制器；未开启、安装失败或已销毁返回 undefined。 */
export function getPageViewController(tracker: Tracker): PageViewController | undefined {
  return controllers.get(tracker);
}

/** @internal 返回精确注销函数，业务只能通过只读查询获取控制面。 */
export function registerPageViewController(tracker: Tracker, controller: PageViewController): () => void {
  controllers.set(tracker, controller);
  return () => { if (controllers.get(tracker) === controller) controllers.delete(tracker); };
}
